import { useRef, useEffect, useCallback } from 'react';

const useDebounceCallback = (callback, time) => {
    const ref = useRef();
    useEffect(() => () => clearTimeout(ref.current), []);
    return useCallback((...args) => {
        clearTimeout(ref.current);
        ref.current = setTimeout(() => {
            callback(...args);
        }, time);
    }, [callback, time]);
};

export { useDebounceCallback };
//# sourceMappingURL=useDebounceCallback.js.map
